module.exports = __webpack_public_path__ + "static/img/prize_box.2b0bf7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/prize_box.png
// module id = NxmL
// module chunks = 9